import {
  Column,
  RTWRadiographyData,
  RTWRadiographySummaryData,
} from "../../../../utils/models";
import Conditional from "../../../common/conditional";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import rtwOverview from "../../../../assets/images/rtwRadiography.png";
import classNames from "../pdf.module.scss";

interface OverviewItemProps {
  label: string;
  value: string | number;
}

interface RTWDigitalRadiographyProps extends RTWRadiographyData {
  summary: RTWRadiographySummaryData;
}

const RTWDigitalRadiography = (props: RTWDigitalRadiographyProps) => {
  return (
    <div className={classNames.digitalRadiography}>
      <div className="container-fluid overflow-hidden">
        <div className="row">
          <div className="col p-0">
            <OverviewItem label="Source" value={props.source} />
            <OverviewItem
              label="Source Activity"
              value={props.sourceActivity}
            />
            <OverviewItem label="Source Size" value={props.sourceSize} />
            <OverviewItem label="Screens" value={props.screens} />
            <OverviewItem label="RT Technique" value={props.rtTechnique} />
          </div>
          <div className="col p-0">
            <OverviewItem label="SDD" value={props.sdd} />
            <OverviewItem label="ODD" value={props.odd} />
            <OverviewItem label="Detector Type" value={props.detectorType} />
            <OverviewItem label="IQI" value={props.iqi} />
            <OverviewItem label="Exposure Time" value={props.exposureTime} />
          </div>
          <div className="col p-0">
            <OverviewItem
              label="Spatial Frequency"
              value={props.spatialFrequency}
            />
            <OverviewItem label="Thickness (mm)" value={props.thickness} />
            <OverviewItem label="Essential IQI" value={props.essentialIQI} />
            <OverviewItem label="UG" value={props.ug} />
            <OverviewItem
              label="Welding Process"
              value={props.weldingProcess}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid p-0">
        <div className={classNames.digitalRadiographySynonyms}>
          SDD = SFD = Source to detector distance; ODD = OFD = Object to
          detector distance
        </div>

        <img
          src={rtwOverview}
          alt="Overview"
          className={classNames.digitalRadiographyOverview}
        />
      </div>

      <div className={classNames.digitalRadiographyTitle}>Result</div>
      <div className={classNames.digitalRadiographySN}>
        <div className={classNames.digitalRadiographySNLeft}>
          DRT Shot Number
        </div>
        <div className={classNames.digitalRadiographySNRight}>
          {props.shotNumber ?? "N/A"}
        </div>
      </div>

      <Conditional isVisible={props.resultScan?.length > 0}>
        <img
          src={props.resultScan?.[0]?.src}
          alt="Scan Result"
          className={classNames.digitalRadiographyScan}
        />
      </Conditional>

      <PDFTablePage data={[props.summary ?? {}]} columns={columns} />
    </div>
  );
};

const OverviewItem = (props: OverviewItemProps) => {
  return (
    <div className={classNames.digitalRadiographyItem}>
      <div className={classNames.digitalRadiographyItemLeft}>{props.label}</div>
      <div className={classNames.digitalRadiographyItemRight}>
        {props.value}
      </div>
    </div>
  );
};

const columns: Column[] = [
  {
    path: "welderID",
    label: "Welder ID",
  },
  {
    path: "weldNumber",
    label: "Weld Number",
  },
  {
    path: "schedule",
    label: "Schedule",
  },
  {
    path: "diameter",
    label: "Diameter (inches)",
  },
  {
    path: "numberOfExposure",
    label: "Number Of Exposure",
  },
  {
    path: "partNumber",
    label: "Location / Part Number",
  },
  {
    path: "density",
    label: "Density",
  },
  {
    path: "defectType",
    label: "Defect / Discontinuity Type",
  },
  {
    path: "defectLength",
    label: "Defect / Discontinuity Length",
  },
  {
    path: "result",
    label: "Accept / Reject",
  },
];

export default RTWDigitalRadiography;
